import React from 'react';
import Icon from '@plone/volto/components/theme/Icon/Icon';

import type { SocialLink } from './FooterTypes';

type FooterSocialProps = {
  links: SocialLink[];
};

// Gets the social links and renders them in the footer

const FooterSocial = ({ links }: FooterSocialProps): JSX.Element => (
  <div className="footer-social" aria-label="Social media links">
    {links.map((link) => (
      <a
        key={link.key}
        className="footer-socialLink"
        href={link.href}
        target="_blank"
        rel="noreferrer"
        aria-label={link.label}
        title={link.label}
      >
        <span className={`footer-socialIcon ${link.iconClassName}`}>
          <Icon name={link.icon} size="24px" />
        </span>
      </a>
    ))}
  </div>
);

export default FooterSocial;
